import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';


import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { NgMaterialMultilevelMenuModule } from 'ng-material-multilevel-menu';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { MultiDatePicker } from './multi-date-picker/multi-date-picker';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TopNavbarComponent } from './top-navbar/top-navbar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OrganisationComponent } from './organisation/organisation.component';
import { VendorComponent } from './vendor/vendor.component';
import { CreateTicketComponent } from './create-ticket/create-ticket.component';
import { ViewTicketComponent } from './view-ticket/view-ticket.component';
import { ModuleComponent } from './module/module.component';
import { CommonSlickgridComponent } from './common-slickgrid/common-slickgrid.component';
import { UrlCreationComponent } from './url-creation/url-creation.component';
import { ClientComponent } from './client/client.component';
import { UsercreationComponent } from './usercreation/usercreation.component';
import { RolesComponent } from './roles/roles.component';
import { UserroleComponent } from './userrole/userrole.component';
import { ModuleClientComponent } from './module-client/module-client.component';
import { UrlMappingComponent } from './url-mapping/url-mapping.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RoleUserComponent } from './role-user/role-user.component';
import { ModuleRoleComponent } from './module-role/module-role.component';
import { RoleActionComponent } from './role-action/role-action.component';
import { AdminUserComponent } from './admin-user/admin-user.component';
import { AdminAuthComponent } from './admin-auth/admin-auth.component';
import { BaseTemplateComponent } from './base-template/base-template.component';
import { ModuleUserRoleComponent } from './module-user-role/module-user-role.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SupportGroupComponent } from './support-group/support-group.component';
import { VendorUserComponent } from './vendor-user/vendor-user.component';
import { VendorSupportComponent } from './vendor-support/vendor-support.component';
import { RoleUserActionComponent } from './role-user-action/role-user-action.component';
import { TicketPropertyComponent } from './ticket-property/ticket-property.component';
import { ProcessAreaComponent } from './process-area/process-area.component';
import { MenusComponent } from './menus/menus.component';
import { CategoryComponent } from './category/category.component';
import { MenuUrlComponent } from './menu-url/menu-url.component';
import { CategoryGroupComponent } from './category-group/category-group.component';
import { ImpactComponent } from './impact/impact.component';
import { UrgencyComponent } from './urgency/urgency.component';
import { PriorityComponent } from './priority/priority.component';
import { SlaComponent } from './sla/sla.component';
import { MatrixComponent } from './matrix/matrix.component';
import { MetadataTableComponent } from './metadata-table/metadata-table.component';
import { MetadataFieldComponent } from './metadata-field/metadata-field.component';
import { MetadataUrlComponent } from './metadata-url/metadata-url.component';
import { MetadataUserTableComponent } from './metadata-user-table/metadata-user-table.component';
import { MetadataUserFieldComponent } from './metadata-user-field/metadata-user-field.component';
import { WorkflowComponent } from './workflow/workflow.component';
import { FlowComponentComponent } from './flow-component/flow-component.component';
import { FlowComponentDetailsComponent } from './flow-component-details/flow-component-details.component';
import { FlowClientComponent } from './flow-client/flow-client.component';
import { InterceptorService } from './interceptor.service';
import { ClientTicketComponent } from './client-ticket/client-ticket.component';
import { TicketTypeComponent } from './ticket-type/ticket-type.component';
import { StatusComponent } from './status/status.component';
import { ClientStatusComponent } from './client-status/client-status.component';
import { BWorkflowComponent } from './b-workflow/b-workflow.component';
import { HolidaysComponent } from './holidays/holidays.component';
import { MaterialFileuploadComponent } from './material-fileupload/material-fileupload.component';
import { TicketFieldsComponent } from './ticket-fields/ticket-fields.component';
import { TicketMenuComponent } from './ticket-menu/ticket-menu.component';
import { SlaClientComponent } from './sla-client/sla-client.component';
import { ReportComponent } from './report/report.component';
import { CSATmodalComponent } from './view-ticket/view-ticket.component';
import { ResizableModule } from 'angular-resizable-element';
import { TicketConfigComponent } from './ticket-config/ticket-config.component';
import { EscalationComponent } from './escalation/escalation.component';
import { PriorityConfigComponent } from './priority-config/priority-config.component';
import { SlaConfigComponent } from './sla-config/sla-config.component';
import { ItAssetManagementColumnComponent } from './it-asset-management-column/it-asset-management-column.component';
import { ItAssetManagementValueComponent } from './it-asset-management-value/it-asset-management-value.component';
import { ItAssetMgmtComponent } from './it-asset-mgmt/it-asset-mgmt.component';
import { AssetDescriptionComponent } from './asset-description/asset-description.component';
import { AssetSearchComponent } from './asset-search/asset-search.component';
import { CreateDocuComponent } from './document/create-docu/create-docu.component';
import { ViewDocuComponent } from './document/view-docu/view-docu.component';
import { AccessSpecifiersComponent } from './document/access-specifiers/access-specifiers.component';
import { CreateTicketLTComponent } from './create-ticket-lt/create-ticket-lt.component';
import { LoginLTComponent } from './login-lt/login-lt.component';
import { RolesLTComponent } from './roles-lt/roles-lt.component';
import { TokenComponent } from './token/token.component';
import { CategoryLavelMappingComponent } from './category-lavel-mapping/category-lavel-mapping.component';
import { NavbarLtComponent } from './navbar-lt/navbar-lt.component';
import { ViewTicketLtComponent } from './view-ticket-lt/view-ticket-lt.component';
import { AddEmailTemplateComponent } from './add-email-template/add-email-template.component';
import { CKEditorModule } from 'ngx-ckeditor';
import { FollowupComponent } from './followup/followup.component';
import { ChartComponent } from './chart/chart.component';
import { EscalateComponent } from './escalate/escalate.component';
import { EscalateSupportGroupComponent } from './escalate-support-group/escalate-support-group.component';
import { FaqComponent } from './faq/faq.component';
import { FaqCategoryComponent } from './faq-category/faq-category.component';
import { FaqMasterComponent } from './faq-master/faq-master.component';
import { SearchComponent } from './search/search.component';
import { ClientSpecificUrlComponent } from './client-specific-url/client-specific-url.component';
import { ModalComponent } from './modal/modal.component';
import { CSATmodalLTComponent } from './modal/modal.component';
import { CSATmodalCITComponent } from './display-ticket-cit/display-ticket-cit.component';
import { CreateTicketCitComponent } from './create-ticket-cit/create-ticket-cit.component';
import { ReportSscComponent } from './report-ssc/report-ssc.component';
import { ClientFuncComponent } from './client-func/client-func.component';
import { DisplayTicketCitComponent } from './display-ticket-cit/display-ticket-cit.component';
import { ViewTicketCitComponent } from './view-ticket-cit/view-ticket-cit.component';
import { TempSscReportComponent } from './temp-ssc-report/temp-ssc-report.component';
import { DashboardCitComponent } from './dashboard-cit/dashboard-cit.component';
import { CheckListComponent } from './check-list/check-list.component';
import { EscalatMasterComponent } from './escalat-master/escalat-master.component';
import { CsatMasterComponent } from './csat-master/csat-master.component';
import { CsatQuestionComponent } from './csat-question/csat-question.component';
import { AutoTicketMasterComponent } from './auto-ticket-master/auto-ticket-master.component';
import { SearchCitComponent } from './search-cit/search-cit.component';
import { AssetReportComponent } from './asset-report/asset-report.component';
import { AssetValidationComponent } from './asset-validation/asset-validation.component';
import { DashboardChrComponent } from './dashboard-chr/dashboard-chr.component';
import { AutoClosureMasterComponent } from './auto-closure-master/auto-closure-master.component';
import { TicketMenuConfigComponent } from './ticket-menu-config/ticket-menu-config.component';
import { CreateTicketChrComponent } from './create-ticket-chr/create-ticket-chr.component';
import { ViewTicketChrComponent } from './view-ticket-chr/view-ticket-chr.component';
import { CSATmodalCHRComponent, DisplayTicketChrComponent } from './display-ticket-chr/display-ticket-chr.component';
import { ScheduleTicketComponent } from './schedule-ticket/schedule-ticket.component';
import { SearchChrComponent } from './search-chr/search-chr.component';
import { EmailTicketComponent } from './email-ticket/email-ticket.component';
import { TicketActivityNotificationMstComponent } from './ticket-activity-notification-mst/ticket-activity-notification-mst.component';
import { FileUploadLogsComponent } from './file-upload-logs/file-upload-logs.component';
import { CreateTicketCrComponent } from './create-ticket-cr/create-ticket-cr.component';
import { EscalationWorkflowComponent } from './escalation-workflow/escalation-workflow.component';
import { ReportSscNewComponent } from './report-ssc-new/report-ssc-new.component';
import { TempSscReportNewComponent } from './temp-ssc-report-new/temp-ssc-report-new.component';
import { ReportCitComponent } from './report-cit/report-cit.component';
import { TempCitReportComponent } from './temp-cit-report/temp-cit-report.component';
import { ReportChrComponent } from './report-chr/report-chr.component';
import { TempChrReportComponent } from './temp-chr-report/temp-chr-report.component';
import { DisplayTicketCrComponent } from './display-ticket-cr/display-ticket-cr.component';
import { CSATmodalCRComponent } from './display-ticket-cr/display-ticket-cr.component';
import { CSATmodalPRComponent } from './display-ticket-pr/display-ticket-pr.component';
import { CreateTicketPrComponent } from './create-ticket-pr/create-ticket-pr.component';
import { DisplayTicketPrComponent } from './display-ticket-pr/display-ticket-pr.component';
import { DashboardReportSlaComponent } from './dashboard-report-sla/dashboard-report-sla.component';
import { DashboardReportCsatComponent } from './dashboard-report-csat/dashboard-report-csat.component';
import { DashboardReportEscalationComponent } from './dashboard-report-escalation/dashboard-report-escalation.component';
import { DashboardReportProductivityComponent } from './dashboard-report-productivity/dashboard-report-productivity.component';
import { DashboardReportTrendComponent } from './dashboard-report-trend/dashboard-report-trend.component';
import { GroupMapCHRComponent } from './group-map-chr/group-map-chr.component';
import { DashboardReportHeatmapComponent } from './dashboard-report-heatmap/dashboard-report-heatmap.component';
import { ViewUserComponent } from './view-user/view-user.component';
import { DashboardReportTrendBarComponent } from './dashboard-report-trend-bar/dashboard-report-trend-bar.component';
import { ViewCategoryComponent } from './view-category/view-category.component';
import { DashboardCitappComponent } from './dashboard-citapp/dashboard-citapp.component';
import { TokenAppComponent } from './token-app/token-app.component';
import { CreateTicketCitAppsComponent } from './create-ticket-cit-apps/create-ticket-cit-apps.component';
import { DisplayTicketCitAppsComponent } from './display-ticket-cit-apps/display-ticket-cit-apps.component';
import { ViewTicketCitAppsComponent } from './view-ticket-cit-apps/view-ticket-cit-apps.component';
import { CSATmodalCITAPPComponent } from './display-ticket-cit-apps/display-ticket-cit-apps.component';
import { CreateTicketCitappCrComponent } from './create-ticket-citapp-cr/create-ticket-citapp-cr.component';
import { DisplayTicketCitappCrComponent } from './display-ticket-citapp-cr/display-ticket-citapp-cr.component';
import { CSATmodalCITAppCRComponent } from './display-ticket-citapp-cr/display-ticket-citapp-cr.component';
import { SearchCitAppsComponent } from './search-cit-apps/search-cit-apps.component';
import { TicketFlowStatusComponent } from './ticket-flow-status/ticket-flow-status.component';
import { InvalidEndUserCategoriesComponent } from './invalid-end-user-categories/invalid-end-user-categories.component';
import { CategoryGroupMapComponent } from './category-group-map/category-group-map.component';
import { SupportGroupHolidaysComponent } from './support-group-holidays/support-group-holidays.component';
import { SupportGrpSlaClientComponent } from './support-grp-sla-client/support-grp-sla-client.component';
import { ReportConfiguratorComponent } from './report-configurator/report-configurator.component';
import { ReportConfiguratorViewComponent } from './report-configurator-view/report-configurator-view.component';
import { ReportCitAppsComponent } from './report-cit-apps/report-cit-apps.component';
import { TempCitAppsReportComponent } from './temp-cit-apps-report/temp-cit-apps-report.component';
import { CategorySlaMappingComponent } from './category-sla-mapping/category-sla-mapping.component';
import { FaqchrComponent } from './faqchr/faqchr.component';
import { BulkCategoryUploadComponent } from './bulk-category-upload/bulk-category-upload.component';
import { FaqDocumentUploadComponent } from './faq-document-upload/faq-document-upload.component';
import { EmailSearchComponent } from './email-search/email-search.component';
import { ActivationComponent } from './activation/activation.component';
import { SupportGroupSpecificUrlComponent } from './support-group-specific-url/support-group-specific-url.component';
import { CategoryReportComponent } from './category-report/category-report.component';
import { NotificationMasterComponent } from './notification-master/notification-master.component';
import { TileCountConfigComponent } from './tile-count-config/tile-count-config.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { DashboardTcsComponent } from './dashboard-tcs/dashboard-tcs.component';
import { CreateTicketTcsComponent } from './create-ticket-tcs/create-ticket-tcs.component';
import { ViewTicketTcsComponent } from './view-ticket-tcs/view-ticket-tcs.component';
import { DisplayTicketTcsComponent } from './display-ticket-tcs/display-ticket-tcs.component';
import { CSATmodalTCSComponent } from './display-ticket-tcs/display-ticket-tcs.component';
import { TempChrReportAdminComponent } from './temp-chr-report-admin/temp-chr-report-admin.component';
import { ReportChrAdminComponent } from './report-chr-admin/report-chr-admin.component';
import { SlaViolationMasterComponent } from './sla-violation-master/sla-violation-master.component';
import { OrgsReportChrComponent } from './orgs-report-chr/orgs-report-chr.component';
import { OrgsTempChrReportComponent } from './orgs-temp-chr-report/orgs-temp-chr-report.component';
import { HybridReportCitComponent } from './hybrid-report-cit/hybrid-report-cit.component';
import { HybridReportCitappComponent } from './hybrid-report-citapp/hybrid-report-citapp.component';
import { BraioMappingMasterComponent } from './braio-mapping-master/braio-mapping-master.component';
import { BulkUserCreationComponent } from './bulk-user-creation/bulk-user-creation.component';
import { CategoryClientModuleComponent } from './category-client-module/category-client-module.component';
import { CategoryClientModuleNewComponent } from './category-client-module-new/category-client-module-new.component';
import { SupportUserModifiedComponent } from './support-user-modified/support-user-modified.component';
import { SupportUserComponent } from './support-user/support-user.component';
import { TicketMenumodifiedComponent } from './ticket-menu-modified/ticket-menu-modified.component';
import { AddEmailTemplateModifiedComponent } from './add-email-template-modified/add-email-template-modified.component';
import { HybridReportOptimizedCitappComponent } from './hybrid-optimized-report-citapp/hybrid-optimized-report-citapp.component';
import { AutoTicketMasterSSCComponent } from './auto-ticket-master-ssc/auto-ticket-master-ssc.component';
import { EmailAttrbuteMasterComponent } from './email-attribute-master/email-attribute-master.component';
import { DashboardJuscoComponent } from './dashboard-jusco/dashboard-jusco.component';
import { DisplayTicketJuscoComponent } from './display-ticket-jusco/display-ticket-jusco.component';
import { CSATmodalJUSCOComponent } from './display-ticket-jusco/display-ticket-jusco.component';
import { ViewTicketJUSCOComponent } from './view-ticket-jusco/view-ticket-jusco.component';
import { SearchJuscoComponent } from './search-jusco/search-jusco.component';
import { enduserApproverMasterScreenComponent } from './enduser_approver_master_screen/enduser_approver_master_screen.component';
import { CreateTicketJuscoComponent } from './create-ticket-jusco/create-ticket-jusco.component';
import { CreateTicketJuscoTaskComponent } from './create-ticket-jusco-task/create-ticket-jusco-task.component';
import { TicketSearchComponent } from './ticket-search/ticket-search.component';
import { DisplayTicketCrJUSCOComponent } from './display-ticket-cr-jusco/display-ticket-cr-jusco.component';
import { CSATmodalCRJUSCOComponent } from './display-ticket-cr-jusco/display-ticket-cr-jusco.component';
import { CreateTicketJUSCOCrComponent } from './create-ticket-jusco-cr/create-ticket-jusco-cr.component';
import { LoginJUSCOComponent } from './login-jusco/login-jusco.component';
import { AutoTicketsToReportGenerationComponent } from './auto_tickets_to_report_generation/auto_tickets_to_report_generation.component';
import { CreateTicketLTSAPComponent } from './create-ticket-ltsap/create-ticket-ltsap.component';
import { ViewTicketLTSAPComponent } from './view-ticket-ltsap/view-ticket-ltsap.component';
import { DisplayTicketLTSAPComponent } from './display-ticket-ltsap/display-ticket-ltsap.component';
import { CSATmodalLTSAPComponent } from './display-ticket-ltsap/display-ticket-ltsap.component';
import { DashboardLTSAPComponent } from './dashboard-ltsap/dashboard-ltsap.component';
import { SearchLTSAPComponent } from './search-ltsap/search-ltsap.component';
import { CreateTicketltsapTaskComponent } from './create-ticket-ltsap-task/create-ticket-ltsap-task.component';

import { CreateTicketltsapTaskArcComponent } from './create-ticket-ltsap-task_archish/create-ticket-ltsap-task_archish.component';
import { CreateTicketLTSAPARCComponent } from './create-ticket-ltsap_archish/create-ticket-ltsap_archish.component';
import { DisplayTicketLTSAPARCComponent, CSATmodalLTSAPArCComponent } from './display-ticket-ltsap_arc/display-ticket-ltsap_arc.component';
import { SearchLTSAPcopyComponent } from './search-ltsap_copy/search-ltsap_copy.component';
import { BulkassignmentComponent } from './bulkassignment/bulkassignment.component';
import { ReAssignmentComponent } from './re-assignment/re-assignment.component';

const customNotifierOptions: NotifierOptions = {
    position: {
        horizontal: {
            position: 'middle',
            distance: 12
        },
        vertical: {
            position: 'top',
            distance: 54,
            gap: 10
        }
    },
    theme: 'material',
    behaviour: {
        autoHide: 10000,
        onClick: 'hide',
        onMouseover: 'pauseAutoHide',
        showDismissButton: true,
        stacking: 4
    },
    animations: {
        enabled: true,
        show: {
            preset: 'slide',
            speed: 300,
            easing: 'ease'
        },
        hide: {
            preset: 'fade',
            speed: 300,
            easing: 'ease',
            offset: 50
        },
        shift: {
            speed: 300,
            easing: 'ease'
        },
        overlap: 150
    }
};

@NgModule({
    declarations: [
        SearchLTSAPcopyComponent,
        DisplayTicketLTSAPARCComponent,
        CSATmodalLTSAPArCComponent,
        CreateTicketLTSAPARCComponent,
        CreateTicketltsapTaskArcComponent,
        CreateTicketltsapTaskComponent,
        SearchLTSAPComponent,
        DashboardLTSAPComponent,
        CSATmodalLTSAPComponent,
        DisplayTicketLTSAPComponent,
        ViewTicketLTSAPComponent,
        CreateTicketLTSAPComponent,
        AutoTicketsToReportGenerationComponent,
        LoginJUSCOComponent,
        CreateTicketJUSCOCrComponent,
        CSATmodalCRJUSCOComponent,
        DisplayTicketCrJUSCOComponent,
        TicketSearchComponent,
        CreateTicketJuscoTaskComponent,
        CreateTicketJuscoComponent,
        enduserApproverMasterScreenComponent,
        SearchJuscoComponent,
        ViewTicketJUSCOComponent,
        CSATmodalJUSCOComponent,
        DisplayTicketJuscoComponent,
        DashboardJuscoComponent,
        EmailAttrbuteMasterComponent,
        AutoTicketMasterSSCComponent,
        HybridReportOptimizedCitappComponent,
        AddEmailTemplateModifiedComponent,
        TicketMenumodifiedComponent,
        SupportUserModifiedComponent,
        CategoryClientModuleNewComponent,
        CategoryClientModuleComponent,
        BulkUserCreationComponent,
        BraioMappingMasterComponent,
        HybridReportCitComponent,
        HybridReportCitappComponent,
        OrgsReportChrComponent,
        OrgsTempChrReportComponent,
        SlaViolationMasterComponent,
        CSATmodalTCSComponent,
        DashboardTcsComponent,
        NotificationMasterComponent,
        CategoryReportComponent,
        SupportGroupSpecificUrlComponent,
        ActivationComponent,
        EmailSearchComponent,
        FaqDocumentUploadComponent,
        BulkCategoryUploadComponent,
        FaqchrComponent,
        CategorySlaMappingComponent,
        TempCitAppsReportComponent,
        ReportCitAppsComponent,
        ReportConfiguratorViewComponent,
        ReportConfiguratorComponent,
        CategoryGroupMapComponent,
        SupportGroupHolidaysComponent,
        SupportGrpSlaClientComponent,
        InvalidEndUserCategoriesComponent,
        TicketFlowStatusComponent,
        CreateTicketCitappCrComponent,
        DisplayTicketCitappCrComponent,
        CSATmodalCITAppCRComponent,
        DashboardReportHeatmapComponent,
        DashboardReportTrendComponent,
        DashboardReportProductivityComponent,
        DashboardReportEscalationComponent,
        DashboardReportCsatComponent,
        DashboardReportSlaComponent,
        DashboardReportTrendBarComponent,
        CSATmodalPRComponent,
        DisplayTicketPrComponent,
        CreateTicketPrComponent,
        CSATmodalCRComponent,
        DisplayTicketCrComponent,
        TempChrReportComponent,
        ReportCitComponent,
        TempCitReportComponent,
        ReportChrComponent,
        ReportSscNewComponent,
        TempSscReportNewComponent,
        EscalationWorkflowComponent,
        FileUploadLogsComponent,
        TicketActivityNotificationMstComponent,
        SearchChrComponent,
        EmailTicketComponent,
        ScheduleTicketComponent,
        CSATmodalCHRComponent,
        AutoClosureMasterComponent,
        TempSscReportComponent,
        ModalComponent,
        SearchComponent,
        ReportSscComponent,
        FaqCategoryComponent,
        FaqMasterComponent,
        AppComponent,
        TopNavbarComponent,
        DashboardComponent,
        OrganisationComponent,
        VendorComponent,
        RolesComponent,
        CreateTicketComponent,
        ViewTicketComponent,
        ModuleComponent,
        CommonSlickgridComponent,
        UrlCreationComponent,
        ClientComponent,
        UsercreationComponent,
        UserroleComponent,
        ModuleClientComponent,
        UrlMappingComponent,
        RoleUserComponent,
        ModuleRoleComponent,
        RoleActionComponent,
        AdminUserComponent,
        AdminAuthComponent,
        BaseTemplateComponent,
        ModuleUserRoleComponent,
        NavbarComponent,
        SupportGroupComponent,
        VendorUserComponent,
        VendorSupportComponent,
        SupportUserComponent,
        ClientSpecificUrlComponent,
        RoleUserActionComponent,
        TicketPropertyComponent,
        ProcessAreaComponent,
        MenusComponent,
        CategoryComponent,
        MenuUrlComponent,
        CategoryGroupComponent,
        ImpactComponent,
        UrgencyComponent,
        PriorityComponent,
        AssetDescriptionComponent,
        SlaComponent,
        MatrixComponent,
        MetadataTableComponent,
        MetadataFieldComponent,
        MetadataUrlComponent,
        MetadataUserTableComponent,
        MetadataUserFieldComponent,
        WorkflowComponent,
        FlowComponentComponent,
        FlowComponentDetailsComponent,
        FlowClientComponent,
        ClientTicketComponent,
        TicketTypeComponent,
        StatusComponent,
        ClientStatusComponent,
        MultiDatePicker,
        BWorkflowComponent,
        HolidaysComponent,
        MaterialFileuploadComponent,
        TicketFieldsComponent,
        TicketMenuComponent,
        SlaClientComponent,
        ReportComponent,
        CSATmodalComponent,
        CSATmodalLTComponent,
        CSATmodalCITComponent,
        CSATmodalCITAPPComponent,
        TicketConfigComponent,
        EscalationComponent,
        PriorityConfigComponent,
        SlaConfigComponent,
        ItAssetManagementColumnComponent,
        ItAssetManagementValueComponent,
        ItAssetMgmtComponent,
        AssetSearchComponent,
        CreateDocuComponent,
        ViewDocuComponent,
        AccessSpecifiersComponent,
        CreateTicketLTComponent,
        LoginLTComponent,
        FaqComponent,
        RolesLTComponent,
        TokenComponent,
        CategoryLavelMappingComponent,
        NavbarLtComponent,
        ViewTicketLtComponent,
        AddEmailTemplateComponent,
        FollowupComponent,
        ChartComponent,
        EscalateComponent,
        EscalateSupportGroupComponent,
        CreateTicketCitComponent,
        ClientFuncComponent,
        DisplayTicketCitComponent,
        ViewTicketCitComponent,
        DashboardCitComponent,
        CheckListComponent,
        EscalatMasterComponent,
        CsatMasterComponent,
        CsatQuestionComponent,
        AutoTicketMasterComponent,
        SearchCitComponent,
        AssetReportComponent,
        AssetValidationComponent,
        DashboardChrComponent,
        TicketMenuConfigComponent,
        CreateTicketChrComponent,
        ViewTicketChrComponent,
        DisplayTicketChrComponent,
        CreateTicketCrComponent,
        GroupMapCHRComponent,
        ViewUserComponent,
        ViewCategoryComponent,
        DashboardCitappComponent,
        TokenAppComponent,
        CreateTicketCitAppsComponent,
        DisplayTicketCitAppsComponent,
        ViewTicketCitAppsComponent,
        SearchCitAppsComponent,
        TileCountConfigComponent,
        CreateTicketTcsComponent,
        ViewTicketTcsComponent,
        DisplayTicketTcsComponent,
        TempChrReportAdminComponent,
        ReportChrAdminComponent,
        BulkassignmentComponent,
        ReAssignmentComponent
    ],
    imports: [
        ColorPickerModule,
        MatListModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgbModule,
        AngularSlickgridModule.forRoot(),
        NotifierModule.withConfig(customNotifierOptions),
        BrowserAnimationsModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        MatTabsModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        NgMaterialMultilevelMenuModule,
        MatRadioModule,
        MatButtonModule, MatChipsModule, MatSelectModule,
        MatIconModule, MatProgressBarModule, MatDialogModule, MatRippleModule,
        CKEditorModule, MatDatepickerModule,
        ResizableModule,
        NgCircleProgressModule.forRoot({
            radius: 100,
            outerStrokeWidth: 16,
            innerStrokeWidth: 8,
            outerStrokeColor: '#78C000',
            innerStrokeColor: '#C7E596',
            animationDuration: 300,
        })
    ],
    entryComponents: [CSATmodalLTSAPArCComponent, CSATmodalComponent, CSATmodalJUSCOComponent, CSATmodalLTSAPComponent, CSATmodalCRJUSCOComponent, CSATmodalLTComponent, CSATmodalCITComponent, CSATmodalCITAPPComponent,
        CSATmodalCHRComponent, CSATmodalCRComponent, CSATmodalPRComponent, CSATmodalCITAppCRComponent, CSATmodalTCSComponent],
    providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }, {
        provide: HTTP_INTERCEPTORS,
        useClass: InterceptorService,
        multi: true
    }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
